import React, { useState, useMemo } from 'react';
import { Select, Typography, Divider, Button } from 'antd';
import StandDetails from '../../pages/Stands/StandDetails';
import { useNavigate } from 'react-router-dom';
import { Stand } from '../../models/stands/stand';
import { Customer } from '../../models/customers';
import { useTranslation } from 'react-i18next';
import './AddOrderToStandModal.css';

interface Props {
    eventId: string;
    customers: Customer[];
    stands: Stand[];
    onClose: () => void;
}

const AddOrderToStandModal: React.FC<Props> = ({ eventId, customers, stands, onClose }) => {
    const { t } = useTranslation();
    const [selectedCustomerId, setSelectedCustomerId] = useState<string | undefined>();
    const [selectedStandId, setSelectedStandId] = useState<string | undefined>();
    const navigate = useNavigate();

    const customerOptions = customers.map(c => ({
        label: c.companyName || c.firstName || c.lastName || c.username,
        value: c.id,
    }));

    const standsForCustomer = useMemo(
        () => stands.filter(s => s.customerId === selectedCustomerId),
        [stands, selectedCustomerId]
    );

    return (
        <div className="add-order-to-stand-modal" data-tour="delivery-modal">
            <Typography.Title level={5}>{t('stand.customer')}</Typography.Title>
            <Select
            data-tour="delivery-modal-customer"
                style={{ width: '100%', marginBottom: 16 }}
                placeholder={t('customer.companyName')}
                options={customerOptions}
                value={selectedCustomerId}
                onChange={setSelectedCustomerId}
                showSearch
                optionFilterProp="label"
            />
            <Typography.Title level={5}>{t('checkList.stand')}</Typography.Title>
            <Select
                data-tour="delivery-modal-stand"
                style={{ width: '100%', marginBottom: 16 }}
                placeholder={t('checkList.stand')}
                options={standsForCustomer.map(s => ({ label: s.name, value: s.id }))}
                value={selectedStandId}
                onChange={setSelectedStandId}
                disabled={!selectedCustomerId}
                showSearch
                optionFilterProp="label"
            />
            <Divider />
            <div className="stand-details-modal-content" data-tour="delivery-modal-stand-details">
                {selectedStandId ? (
                    <StandDetails standId={selectedStandId} />
                ) : (
                    <Typography.Text type="secondary">{t('stand.selectStand')}</Typography.Text>
                )}
            </div>
            <div className="add-order-to-stand-modal-footer">
                <Button onClick={onClose} style={{ marginLeft: 8 }}>
                    {t('general.cancel')}
                </Button>
            </div>
        </div>
    );
};

export default AddOrderToStandModal;
